// app/models/api/graph/enums/job_event_signal_reason_enum.rb
const NEVER_STARTED_SIGNAL_REASONS = [
  "SIGNATURE_REJECTED",
  "AGENT_REFUSED",
  "AGENT_INCOMPATIBLE",
  "PROCESS_RUN_ERROR",
  "STACK_ERROR",
];
const PROCESS_KILLED_SIGNAL_REASONS = ["CANCEL", "AGENT_STOP"];

export { NEVER_STARTED_SIGNAL_REASONS, PROCESS_KILLED_SIGNAL_REASONS };
